import { default as MuiCardMedia } from '@mui/material/CardMedia';

/**
 * CardMedia displays an image or video within a Card.
 *
 * Demos:
 *
 * - [Card — Media](https://unify.workiva.org/components/card?tab=code)
 *
 * API:
 *
 * - [CardMedia API](https://unify.workiva.org/components/card?tab=props#cardmedia)
 */
export const CardMedia = MuiCardMedia;
export { type CardMediaProps, cardMediaClasses } from '@mui/material/CardMedia';
